/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues, typeFirst } from '../runtime';
/**
 * 
 * @export
 * @interface UserCatalogDto
 */
export interface UserCatalogDto {
    /**
     * 
     * @type {number}
     * @memberof UserCatalogDto
     */
    id: number;
    /**
     * 
     * @type {string}
     * @memberof UserCatalogDto
     */
    readonly creationTime?: string;
    /**
     * 
     * @type {number}
     * @memberof UserCatalogDto
     */
    readonly creatorUserId?: number | null;
    /**
     * 
     * @type {string}
     * @memberof UserCatalogDto
     */
    lastModificationTime?: string | null;
    /**
     * 
     * @type {number}
     * @memberof UserCatalogDto
     */
    readonly lastModifierUserId?: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof UserCatalogDto
     */
    readonly isDeleted?: boolean;
    /**
     * 
     * @type {number}
     * @memberof UserCatalogDto
     */
    readonly deleterUserId?: number | null;
    /**
     * 
     * @type {string}
     * @memberof UserCatalogDto
     */
    readonly deletionTime?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UserCatalogDto
     */
    userName: string;
    /**
     * 
     * @type {string}
     * @memberof UserCatalogDto
     */
    title?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UserCatalogDto
     */
    firstName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UserCatalogDto
     */
    middleName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UserCatalogDto
     */
    lastName: string;
    /**
     * 
     * @type {string}
     * @memberof UserCatalogDto
     */
    emailAddress: string;
    /**
     * 
     * @type {string}
     * @memberof UserCatalogDto
     */
    lastLoginTime?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UserCatalogDto
     */
    profilePictureId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UserCatalogDto
     */
    readonly fullName: string;
    /**
     * 
     * @type {string}
     * @memberof UserCatalogDto
     */
    iuid?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UserCatalogDto
     */
    $type?: UserCatalogDtoTypeEnum;
}


/**
 * @export
 */
export const UserCatalogDtoTypeEnum = {
    PtwPtw100AppZeroApplicationSharedAuthorizationUsersDtoUserCatalogDtoPtwPtw100AppZeroApplicationShared: 'Ptw.Ptw100.AppZero.Application.Shared.Authorization.Users.Dto.UserCatalogDto, Ptw.Ptw100.AppZero.Application.Shared'
} as const;
export type UserCatalogDtoTypeEnum = typeof UserCatalogDtoTypeEnum[keyof typeof UserCatalogDtoTypeEnum];



/**
 * Check if a given object implements the UserCatalogDto interface.
 */
export function instanceOfUserCatalogDto(value?: unknown): value is UserCatalogDto {
    return !!value && typeof value === 'object' && "$type" in value && value.$type === Object.values(UserCatalogDtoTypeEnum)[0];
}

export function UserCatalogDtoFromJSON(json: any): UserCatalogDto {
    return UserCatalogDtoFromJSONTyped(json, false);
}

export function UserCatalogDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): UserCatalogDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'creationTime': json['creationTime'] == null ? undefined : json['creationTime'],
        'creatorUserId': json['creatorUserId'] == null ? undefined : json['creatorUserId'],
        'lastModificationTime': json['lastModificationTime'] == null ? undefined : json['lastModificationTime'],
        'lastModifierUserId': json['lastModifierUserId'] == null ? undefined : json['lastModifierUserId'],
        'isDeleted': json['isDeleted'] == null ? undefined : json['isDeleted'],
        'deleterUserId': json['deleterUserId'] == null ? undefined : json['deleterUserId'],
        'deletionTime': json['deletionTime'] == null ? undefined : json['deletionTime'],
        'userName': json['userName'],
        'title': json['title'] == null ? undefined : json['title'],
        'firstName': json['firstName'] == null ? undefined : json['firstName'],
        'middleName': json['middleName'] == null ? undefined : json['middleName'],
        'lastName': json['lastName'],
        'emailAddress': json['emailAddress'],
        'lastLoginTime': json['lastLoginTime'] == null ? undefined : json['lastLoginTime'],
        'profilePictureId': json['profilePictureId'] == null ? undefined : json['profilePictureId'],
        'fullName': json['fullName'],
        'iuid': json['iuid'] == null ? undefined : json['iuid'],
        '$type': json['$type'] == null ? undefined : json['$type'],
    };
}

export function UserCatalogDtoToJSON(value?: Omit<UserCatalogDto, 'creationTime'|'creatorUserId'|'lastModifierUserId'|'isDeleted'|'deleterUserId'|'deletionTime'|'fullName'> | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return typeFirst({
        
        'id': value['id'],
        'lastModificationTime': value['lastModificationTime'],
        'userName': value['userName'],
        'title': value['title'],
        'firstName': value['firstName'],
        'middleName': value['middleName'],
        'lastName': value['lastName'],
        'emailAddress': value['emailAddress'],
        'lastLoginTime': value['lastLoginTime'],
        'profilePictureId': value['profilePictureId'],
        'iuid': value['iuid'],
        '$type': value['$type'],
    });
}

